import type { IRouteItem } from "../types";

/** Keep legacy order requests compatible without dropping explicit windows.
 * [] means deliberately unrestricted; null/undefined mean no explicit field.
 */
export const serializeOrderStop = <
  T extends Pick<IRouteItem, "requiredTimeWindows" | "preferredTimeWindows">,
>(
  stop: T,
) => {
  const { requiredTimeWindows, preferredTimeWindows, ...fields } = stop;
  return {
    ...fields,
    ...(requiredTimeWindows != null ? { requiredTimeWindows } : {}),
    ...(preferredTimeWindows != null ? { preferredTimeWindows } : {}),
  };
};
